<template>
  <div id="program-reminder-dialog" class="custom-modal">
    <HolaconLottie v-if="loading == 'updateScreenLoading' && form == null" key="create-loading" />

    <div class="modal-body" v-else>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-button-group class="d-flex flex-row">
            <el-button round size="mini" class="w-100" :type="type == 0 ? 'primary' : 'default'" @click="type = 0">{{ $t("components.automatedmessages.programReminder.defaultEn") }}</el-button>
            <el-button round size="mini" class="w-100" :type="type == 1 ? 'primary' : 'default'" @click="type = 1"> {{ $t("components.automatedmessages.programReminder.tr") }}</el-button>
          </el-button-group>
        </el-col>
        <el-col :span="24" class="mt-3 english" v-if="type == 0">
          <el-row :gutter="10">
            <el-col :span="24">
              <div class="registerform-input-container">
                <div class="title">
                  <div>
                    <label>{{ $t("components.automatedmessages.programReminder.subject") }}</label>

                    <el-tooltip content="Content" placement="bottom">
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </div>
                </div>
                <el-input v-model="form.subject" :class="$inputError('subject', validationErrors)"></el-input>
                <span class="error">{{ $errorMessage("subject", validationErrors) }}</span>
              </div>
            </el-col>
            <el-col :span="24" class="mt-3">
              <div class="registerform-input-container">
                <div class="title">
                  <div>
                    <label>{{ $t("components.automatedmessages.programReminder.variables") }}</label>
                    <el-tooltip content="Content" placement="bottom">
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </div>
                </div>

                <el-select v-model="addedObj" filterable v-if="groups.length > 0">
                  <el-option-group v-for="(group, groupIndex) in groups" :key="groupIndex + '-dynamicGroup'" :label="group">
                    <el-option v-for="item in dynamicParams.filter(x => x.group == group)" :key="item.key" :label="item.title" :value="item.key"></el-option>
                  </el-option-group>
                </el-select>
              </div>
            </el-col>
            <el-col :span="24" class="mt-3">
              <div class="registerform-input-container">
                <div class="title">
                  <div>
                    <label>{{ $t("components.automatedmessages.programReminder.notification") }}</label>
                    <el-tooltip content="Content" placement="bottom">
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </div>
                </div>
                <el-input type="textarea" v-model="form.message" :rows="4" :class="$inputError('message', validationErrors)"></el-input>
                <span class="error">{{ $errorMessage("message", validationErrors) }}</span>
              </div>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="24" class="mt-3 turkish" v-if="type == 1">
          <el-row :gutter="10">
            <el-col :span="24">
              <div class="registerform-input-container">
                <div class="title">
                  <div>
                    <label>{{ $t("components.automatedmessages.programReminder.subject") }}</label>
                    <el-tooltip content="Content" placement="bottom">
                      <i class="el-icon-info"></i>
                    </el-tooltip> 
                  </div>
                </div>
                <el-input v-model="form.subjectTr" :class="$inputError('subjectTr', validationErrors)"></el-input>
                <span class="error">{{ $errorMessage("subjectTr", validationErrors) }}</span>
              </div>
            </el-col>
            <el-col :span="24" class="mt-3">
              <div class="registerform-input-container">
                <div class="title">
                  <div>
                    <label>{{ $t("components.automatedmessages.programReminder.variables") }}</label>
                    <el-tooltip content="Content" placement="bottom">
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </div>
                </div>

                <el-select v-model="addedObj2" filterable v-if="groups.length > 0">
                  <el-option-group v-for="(group, groupIndex) in groups" :key="groupIndex + '-dynamicGroup'" :label="group">
                    <el-option v-for="item in dynamicParams.filter(x => x.group == group)" :key="item.key" :label="item.title" :value="item.key"></el-option>
                  </el-option-group>
                </el-select>
              </div>
            </el-col>
            <el-col :span="24" class="mt-3">
              <div class="registerform-input-container">
                <div class="title">
                  <div>
                    <label>{{ $t("components.automatedmessages.programReminder.notification") }}</label>
                    <el-tooltip content="Content" placement="bottom">
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </div>
                </div>
                <el-input type="textarea" v-model="form.messageTr" :rows="4" :class="$inputError('messageTr', validationErrors)"></el-input>
                <span class="error">{{ $errorMessage("messageTr", validationErrors) }}</span>
              </div>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="24" class="mt-2">
          <el-row :gutter="10">
            <el-col class="mt-2" :span="24">
              <div class="custom-section-container">
                <div class="section-header">
                  <div class="section-title">
                    <div class="section-head">
                      <label>{{ $t("components.automatedmessages.programReminder.settings") }}</label>
                      <!-- <el-tooltip content="Content" placement="bottom">
                          <i class="el-icon-info"></i>
                        </el-tooltip> -->
                    </div>
                    <span>{{ $t("components.automatedmessages.programReminder.settingsMsg") }}</span>
                  </div>
                  <div class="section-accordion" @click="settingsDock = !settingsDock">
                    <i class="fa" :class="settingsDock ? 'fa-angle-up' : 'fa-angle-down'"></i>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="settingsDock">
                    <div class="custom-set-container" :class="form.isActive ? 'sactive' : 'spassive'">
                      <div class="custom-set-inner">
                        <i class="fa" :class="form.isActive ? 'fa-eye' : 'fa-eye-slash'"></i>
                        <div class="custom-set-info">
                          <label
                            >{{ $t("components.automatedmessages.programReminder.show") }}
                            <el-tooltip content="Content" placement="bottom">
                              <i class="el-icon-info"></i>
                            </el-tooltip>
                          </label>
                          <span>{{ $t("components.automatedmessages.programReminder.showMsg") }}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="form.isActive"></el-switch>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <div class="modal-footer" slot="footer">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("components.automatedmessages.programReminder.close") }}</el-button>
        <!-- <el-popconfirm @confirm="deleteItem" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
          <el-button slot="reference" type="danger" icon="fas fa-trash"> Sil</el-button>
        </el-popconfirm> -->
      </div>
      <div class="right-buttons">
        <el-button type="primary" :loading="loading == 'save'" :disabled="loading == 'save'" @click="save">{{ $t("components.automatedmessages.programReminder.save") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProgramReminder",
  props: ["id"],
  data() {
    return {
      validationErrors: [],
      type: 0,
      addedObj: null,
      addedObj2: null,
      groups: [],
      form: null,
      settingsDock: false,
      loading: false,
      listShort: null
    };
  },
  computed: {
    dynamicParams() {
      return this.$store.getters.getDynamicParams;
    }
  },
  methods: {
    async save() {
      if (this.listShort != null) clearTimeout(this.listShort);
      this.loading = "save";
      var res = await this.$store.dispatch("addUpdatePush", this.form);
      this.validationErrors = res.data.validationErrors;
      if (!res.data.alert.hasError) {
        await this.$store.dispatch("getAutomatedMessagesList");
      }
      this.listShort = setTimeout(async () => {
        this.loading = false;
      }, 500);
    }
  },
  async created() {
    this.loading = "updateScreenLoading";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      if (this.id != null) {
        var res = await this.$store.dispatch("getAutomatedMessage", this.id);

        if (!res.data.alert.hasError) {
          this.form = res.data.data.item;
          await this.$store.dispatch("getDynamicParams", { type: this.form.type, isPrintScheme: false });
          this.groups = this.dynamicParams.map(x => {
            return x.group;
          });
          this.groups = [...new Set(this.groups)];
        } else {
          this.$emit("closeMe");
        }
      } else {
        this.$emit("closeMe");
      }
      this.loading = false;
    }, 500);
  },
  watch: {
    addedObj: function() {
      if (this.addedObj != null) {
        if (this.form.message != null) {
          this.form.message += " " + this.addedObj;
        } else {
          this.form.message = this.addedObj;
        }
      }
    },
    addedObj2: function() {
      if (this.addedObj2 != null) {
        if (this.form.messageTr != null) {
          this.form.messageTr += " " + this.addedObj2;
        } else {
          this.form.messageTr = this.addedObj2;
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.registerform-input-container {
  .el-upload {
    width: 100% !important;
  }
  .tag-container {
    gap: 1rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .badge-list {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    .badger {
      border-radius: 8px;
      background-color: #f3f3f3;
      height: 20px;
      padding: 10px;
    }
  }
  .title {
    i {
      cursor: pointer;
    }
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.5rem;
    gap: 0.3rem;
    label {
      font-weight: bold;
      color: black;
      margin-bottom: 0;
    }
    .title-container {
      display: flex;
      flex-direction: row;
      gap: 1rem;
      align-items: center;
    }
  }
  display: flex;
  flex-direction: column;
  .el-input-number {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/automatedmessages/ProgramReminder.vue